import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-skip-one-forward.tsx
/**
* icon.24.skip.one.forward
*
* Keywords: triangle, right, forward, next, chevron, directional, navigation, proceed
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYuNSA2LjVBLjUuNSAwIDAgMSA3IDd2MTBhLjUuNSAwIDAgMS0xIDBWN2EuNS41IDAgMCAxIC41LS41bTIuNDk5IDEuNjAzYTEuNiAxLjYgMCAwIDEgMi40MDQtMS4zODRsNi44NSAzLjk4MmExLjUgMS41IDAgMCAxIDAgMi41OTRsLTYuODUgMy45ODFBMS42IDEuNiAwIDAgMSA5IDE1Ljg5NHptMS45MDEtLjUyYS42LjYgMCAwIDAtLjkwMS41MnY3Ljc5YS42LjYgMCAwIDAgLjkwMS41Mmw2Ljg1Mi0zLjk4M2EuNS41IDAgMCAwIDAtLjg2NHoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24950-58437
*/
const Icon24SkipOneForward = memo(function Icon24SkipOneForward(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M6.5 6.5A.5.5 0 0 1 7 7v10a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5m2.499 1.603a1.6 1.6 0 0 1 2.404-1.384l6.85 3.982a1.5 1.5 0 0 1 0 2.594l-6.85 3.981A1.6 1.6 0 0 1 9 15.894zm1.901-.52a.6.6 0 0 0-.901.52v7.79a.6.6 0 0 0 .901.52l6.852-3.983a.5.5 0 0 0 0-.864z"
		})
	});
});
//#endregion
export { Icon24SkipOneForward };

//# sourceMappingURL=icon-24-skip-one-forward.js.map